// extracted by css-extract-rspack-plugin
export default {"warningText":"DeleteModal__warningText--hWACq"};